<template>
  <div>
    <BlockUI v-if="loading" message="Loading">
      <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
    </BlockUI>
    <v-card>
      <v-toolbar card>
        <v-text-field clearable
          append-icon="search"
          label="ค้นหา"
          single-line
          hide-details
          v-model="pagination.q"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn fab dark small color="primary" @click.native.stop="addItem" class="text-xs-center" slot="activator">
            <v-icon dark>playlist_add</v-icon>
          </v-btn>
          <span>เพิ่มเจ้าหน้าที่</span>
        </v-tooltip>
      </v-toolbar>
      <v-data-table :loading="loading"
          :headers="headers"
          :items="loadedItems"
          :total-items="totalItems"
          :pagination.sync="pagination"
          class="elevation-0"
        >
        <v-progress-linear slot="progress" color="teal" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <tr @click="editItem(props.item)">
            <td class="text-xs-left">{{ ((pagination.page - 1) * pagination.rowsPerPage) + props.index + 1 }}</td>
            <td class="text-xs-left">{{ props.item.username }}</td>
            <td class="text-xs-left">{{ props.item.fullname }}</td>
            <td class="text-xs-left">{{ props.item.email }}</td>
            <td class="text-xs-center">
              <v-icon color="green" v-if="props.item.enabled">check</v-icon>
              <v-icon color="red" v-else>report_problem</v-icon>
            </td>
            <td class="text-xs-left">
              <v-list v-if="props.item.gangs">
                <v-list-tile v-for="gang in props.item.gangs" :key="gang.id">
                  <v-list-tile-content>
                    <v-list-tile-title v-text="gang.authority"></v-list-tile-title>
                    <v-list-tile-sub-title>{{ gang.description }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </td>
          </tr>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop, itemsLength }">
          From {{ pageStart }} to {{ pageStop }} of {{ itemsLength }}
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="addedDialog" full-width persistent>
      <add-officer-dialog :dialog="addedDialog"></add-officer-dialog>
    </v-dialog>
    <v-dialog v-model="editedDialog" full-width persistent>
      <show-officer-dialog :dialog="editedDialog" :officer="editedItem" v-if="(editedIndex > -1) && editedItem.id"></show-officer-dialog>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import swal from 'sweetalert2'
import AddOfficerDialog from './addOfficerDialog'
import ShowOfficerDialog from './showOfficerDialog'

export default {
  name: 'Officer',
  components: { AddOfficerDialog, ShowOfficerDialog },
  data () {
    return {
      addedDialog: false,
      editedDialog: false,
      loading: false,
      valid: false,
      headers: [
        { text: '#', value: 'idx', sortable: false, align: 'left' },
        { text: 'ชื่อผู้ใช้', value: 'username', sortable: true, align: 'left' },
        { text: 'ชื่อ', value: 'fullname', sortable: true, align: 'left' },
        { text: 'อีเมล', value: 'email', sortable: true, align: 'left' },
        { text: 'เปิดใช้งาน', value: 'enabled', sortable: true, align: 'center' },
        { text: 'บทบาท', value: 'gangs', sortable: false, align: 'left' }
      ],
      companyHeaders: [
        { text: '#', value: 'idx', sortable: false, align: 'center' },
        { text: 'เลขที่ผู้เสียภาษี', value: 'code', sortable: true, align: 'left' },
        { text: 'ผู้รับใบอนุญาต', value: 'name', sortable: true, align: 'left' },
        { text: 'ประเภท', value: 'companyType', sortable: true, align: 'center' },
        { text: 'เปิดใช้งาน', value: 'enabled', sortable: true, align: 'center' }
      ],
      search: '',
      defaultItem: {
        id: null,
        username: null,
        enabled: null,
        gangs: []
      },
      editedItem: {
        id: null,
        username: null,
        enabled: null,
        gangs: []
      },
      editedIndex: -1,
      pagination: {
        q: '',
        sortBy: 'username',
        page: 1,
        rowsPerPage: 10,
        descending: false
      },
      totalItems: 0,
      loadedItems: [],
      rules: {
        required: value => !!value || 'กรุณากรอกข้อมูล.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'รูปแบบอีเมลไม่ถูกต้อง.'
        }
      },
      gangList: []
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? `New ${this.$options.name}` : `Edit ${this.$options.name}`
    }
  },
  methods: {
    reset () {
      this.editedIndex = -1
      this.editedItem = Object.assign({}, this.defaultItem)
    },
    addItem () {
      this.reset()
      this.addedDialog = true
    },
    editItem (item) {
      this.editedIndex = this.loadedItems.indexOf(item)
      this.editedItem = item
      this.editedDialog = true
    },
    closeAddedDialog () {
      this.reset()
      this.addedDialog = false
      setTimeout(() => this.reload(this), 300)
    },
    closeEditedDialog () {
      this.reset()
      this.editedDialog = false
      setTimeout(() => this.reload(this), 300)
    },
    reload: _.debounce((self) => {
      self.loading = true
      self.reset()
      self.$store.dispatch('officer/loadItems', self.pagination)
        .then((response) => {
          self.totalItems = response.data.totalItems
          self.loadedItems = response.data.items
          self.loading = false
        }).catch((error) => {
          self.loading = false
          swal('เกิดข้อผิดพลาด!', (error.response.data) ? error.response.data.message : error.message, 'error')
        })
    }, 1000)
  },
  watch: {
    'pagination.rowsPerPage' () {
      this.reload(this)
    },
    'pagination.q' () {
      this.reload(this)
    },
    'pagination.page' () {
      this.reload(this)
    },
    'pagination.descending' () {
      this.reload(this)
    }
  },
  created () {
    this.reload(this)
    this.$store.dispatch('gang/list')
      .then(response => {
        this.gangList = response.data
      })
  },
  mounted () {
    this.$events.on('closeDialog', (eventData) => {
      if (eventData === 'addedDialog') {
        this.closeAddedDialog()
        this.createRowLiningRequest = null
      } else if (eventData === 'editedDialog') {
        this.closeEditedDialog()
      }
    })
  },
  beforeDestroy () {
    this.$events.remove('closeDialog')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/officer/index.vue